import type { ReactNode } from 'react';

export const symbol_reset_image: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-580H150q-13 0-21.5-8.5T120-610v-170q0-13 8.5-21.5T150-810q13 0 21.5 8.5T180-780v101q48-73 127-117t173-44q113 0 202 60.5T812-628q5 11 .5 23T797-588q-11 5-23 .5T757-603q-34-75-108.5-126T480-780q-81 0-147.5 38.5T226-640h94q13 0 21.5 8.5T350-610q0 13-8.5 21.5T320-580Zm-54 343h429q9 0 13-8t-1-16L590-417q-5-6-12-6t-12 6L446-262l-81-111q-5-6-12-6t-12 6l-86 112q-6 8-2 16t13 8ZM180-80q-25 0-42.5-17.5T120-140v-330q0-13 8.5-21.5T150-500q13 0 21.5 8.5T180-470v330h600v-330q0-13 8.5-21.5T810-500q13 0 21.5 8.5T840-470v330q0 25-17.5 42.5T780-80H180Z"
		/>
	</svg>
);
